import { render, staticRenderFns } from "./notification.bienetre.vue?vue&type=template&id=5d40eb85&"
import script from "./notification.bienetre.vue?vue&type=script&lang=js&"
export * from "./notification.bienetre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports